import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { userManagement, userManagementBaseUrl } from "../endpoints";

export const carbonProjectService = createApi({
  reducerPath: "carbonProjectService",
  baseQuery: fetchBaseQuery({
    baseUrl: userManagementBaseUrl,
    prepareHeaders: (headers) => {
      let token = localStorage.getItem("token");
      if (!token) {
        const localUserStr = localStorage.getItem("localUser");
        if (localUserStr) {
          try {
            const localUser = JSON.parse(localUserStr);
            token = localUser?.token;
          } catch (e) {
            console.error("Error parsing localUser from localStorage", e);
          }
        }
      }
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["CarbonProject"],
  endpoints: (builder) => ({
    getCarbonProjects: builder.query<any, any>({
      query: (params) => ({
        url: userManagement.carbonProjectController.search,
        method: "POST",
        body: params,
      }),
      providesTags: ["CarbonProject"],
    }),
    searchCarbonProjects: builder.mutation<any, any>({
      query: (params) => ({
        url: userManagement.carbonProjectController.search,
        method: "POST",
        body: params,
      }),
      invalidatesTags: ["CarbonProject"],
    }),
    getAllCarbonProjects: builder.query<any, void>({
      query: () => ({
        url: userManagement.carbonProjectController.findAll,
        method: "GET",
      }),
      providesTags: ["CarbonProject"],
    }),
    saveCarbonProject: builder.mutation<any, any>({
      query: (data) => ({
        url: userManagement.carbonProjectController.save,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["CarbonProject"],
    }),
    updateCarbonProject: builder.mutation<any, { id: number; data: any }>({
      query: ({ id, data }) => ({
        url: `${userManagement.carbonProjectController.update}/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["CarbonProject"],
    }),
    deleteCarbonProject: builder.mutation<any, { id: number; type?: string }>({
      query: ({ id, type = "soft" }) => ({
        url: `${userManagement.carbonProjectController.delete}/${id}`,
        method: "DELETE",
        params: { type },
      }),
      invalidatesTags: ["CarbonProject"],
    }),
    bulkUploadCarbonProject: builder.mutation<any, FormData>({
      query: (formData) => ({
        url: userManagement.carbonProjectController.uploadBulk,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["CarbonProject"],
    }),
    getCarbonProjectById: builder.mutation<any, { id: number; token?: string }>({
      query: ({ id, token }) => ({
        url: `${userManagement.carbonProjectController.getById}/${id}`,
        method: "GET",
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      }),
    }),
    findAllCarbonProject: builder.mutation<any, { token?: string }>({
      query: (body) => ({
        url: userManagement.carbonProjectController.findAll,
        method: "GET",
        headers: body?.token ? { Authorization: `Bearer ${body.token}` } : undefined,
      }),
    }),
  }),
});

export const {
  useGetCarbonProjectsQuery,
  useGetAllCarbonProjectsQuery,
  useSaveCarbonProjectMutation,
  useUpdateCarbonProjectMutation,
  useDeleteCarbonProjectMutation,
  useBulkUploadCarbonProjectMutation,
  useGetCarbonProjectByIdMutation,
  useFindAllCarbonProjectMutation,
  useSearchCarbonProjectsMutation,
} = carbonProjectService;
